// extracted by mini-css-extract-plugin
module.exports = {"Switcher":"Switcher_Switcher__gofhu","Disabled":"Switcher_Disabled__NL1eG","Input":"Switcher_Input__ebU80","Slider":"Switcher_Slider__kcNtW"};